import { createContext, useContext, useState, useEffect, useMemo } from 'react';
import Cookies from 'js-cookie';
import { getAppTheme } from './css/theme';
import { useTranslation } from 'react-i18next';
import { ThemeProvider, CssBaseline } from '@mui/material';
export const ColorModeContext = createContext({
  toggleColorMode: () => { },
  mode: 'light',
});

export const useColorMode = () => useContext(ColorModeContext);

export const ColorModeProvider = ({ children }) => {
  const [mode, setMode] = useState(Cookies.get('themeMode') || 'light');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', mode);
    Cookies.set('themeMode', mode, { expires: 365, sameSite: 'strict' });
  }, [mode]);

  const colorMode = useMemo(
    () => ({

      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
      },
      mode,
    }),
    [mode]
  );
  const { i18n } = useTranslation();
  const lang = i18n.language?.slice(0, 2) || 'fr';
  const theme = useMemo(() => getAppTheme(mode, lang), [mode, lang]);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};
